<section class="logout-page">
  <div class="logout-card">
    @if (status === LogoutStatus.PENDING) {
      <kendo-loader size="small"></kendo-loader>
      <h2>Signing you out...</h2>
      <p>Please wait while we close your session.</p>
    }

    @if (status === LogoutStatus.COMPLETED) {
      <h2>Signed out</h2>
      @if (idpLogoutUrl) {
        <p>You are signed out of this app. You can also sign out from your identity provider.</p>
        <div class="actions">
          <button
            kendoButton
            type="button"
            themeColor="primary"
            (click)="logoutFromIdp()"
          >
            Log out from identity provider
          </button>
          <a (click)="goToLogin()">Go to sign in</a>
        </div>
      } @else {
        <p>You can sign in again any time.</p>
        <a (click)="goToLogin()">Go to sign in</a>
      }
    }

    @if (status === LogoutStatus.FAILED) {
      <h2>Sign out failed</h2>
      <p>We could not complete sign out automatically.</p>
      <a (click)="goToLogin()">Return to sign in</a>
    }
  </div>
</section>
